import { createTranslations } from '@npco/utils-translations'

export const removeBusinessModalTranslations = createTranslations({
  title: 'Remove Business?',
  primaryButtonLabel: 'Remove Business',
  secondaryButtonLabel: 'Cancel',
  warningMessage:
    'You will no longer have access to this Business. If you have a unique email and password you will still be able to log into this business separately.',
})
